// Action Types

const OPEN_OPEN = "common/OPEN_OPEN";
const SELECTED_SUBJECT = "common/SELECTED_SUBJECT";
const SELECTED_SMST = "common/SELECTED_SMST";
const ALLTAB_MEMBER = "common/ALLTAB_MEMBER";
const ATTEND_DONE = "common/ATTEND_DONE";

// Action Creators
export const openPopupPreiod = (data) => ({ type: OPEN_OPEN, data });
export const setSubject = (data) => ({ type: SELECTED_SUBJECT, data });
export const setSMST = (data) => ({ type: SELECTED_SMST, data });
export const setAlltabMember = (data) => ({ type: ALLTAB_MEMBER, data });
// 출석 처리 결과 (attend API 의 SUCCESS_YN === "Y")
export const setAttendDone = (data) => ({ type: ATTEND_DONE, data });

// isOpen: 현재일자 기준 팝업 오픈여부 (Y / N)
// isEvent: 이벤트 신청여부 (true / false)

// InitialState
const initStatus = {
    popup: {
        endDate: "",
        endTime: "",
        srtDate: "",
        srtTime: "",
        currentDate: "",
        isOpen: "",
        popSeq: "",
        isEvent: false,
    },
    selectedSubject: "",
    selectedSMSTCD: "",
    isAlltabMember: false,
    isAttendDone: false,
};

export default function commonReducer(state = initStatus, action) {
    switch (action.type) {
        case OPEN_OPEN:
            return {
                ...state,
                popup: {
                    endDate: action.data.endDate,
                    endTime: action.data.endTime,
                    srtDate: action.data.srtDate,
                    srtTime: action.data.srtTime,
                    currentDate: action.data.currentDate,
                    isOpen: action.data.isOpen,
                    popSeq: action.data.popSeq,
                    isEvent: action.data.isEvent,
                },
            };

        case SELECTED_SUBJECT:
            return {
                ...state,
                selectedSubject: action.data,
            };

        case SELECTED_SMST:
            return {
                ...state,
                selectedSMSTCD: action.data,
            };

        case ALLTAB_MEMBER:
            return {
                ...state,
                isAlltabMember: action.data,
            };

        case ATTEND_DONE:
            return {
                ...state,
                isAttendDone: action.data,
            };

        default:
            return state;
    }
}
